import React from 'react'
import { Link } from 'react-router-dom'

import { CustomSelect } from '../CustomSelect/CustomSelect'

import Viber from '../../icons/viber.jpeg'
import Instagram from '../../icons/instagram.jpeg'
import Telegram from '../../icons/telegram.jpeg'
import XIcon from '../../icons/x_footer.png'

import './footer.css'

const FooterColumns = (
  <>
    <div className='footer__column'>
      <Link to="/about_us">Про нас</Link>
      <Link to="/page/how_to_order">Як замовити</Link>
      <Link to="/delivery">Доставка і оплата</Link>
    </div>
    <div className='footer__column'>
      <Link to="/page/warranty">Гарантія</Link>
      <Link to="/news">Новини</Link>
      <Link to="/contacts">Контакти</Link>
    </div>
  </>
)


const FooterMobile = ({ instagram, telegram, viber, phone, phoneOptions }) => (
  <footer className='footer__mobile'>
    <div className='footer__section'>
      {FooterColumns}
    </div>
    <div className='footer__section'>
      <CustomSelect
        value={phone}
        className='phone phone-dropdown flex-container--bottom-10'
        options={phoneOptions}
      >
        {phone}
      </CustomSelect>
      <div className='socials flex-container--bottom-10'>
        <a href={viber} target='_blank' rel="noopener noreferrer">
          <img src={Viber} alt='viber' />
        </a>
        <a href={instagram} target='_blank' rel="noopener noreferrer">
          <img src={Instagram} alt='instagram' />
        </a>
        <a href={telegram} target='_blank' rel="noopener noreferrer">
          <img src={Telegram} alt='telegram' />
        </a>
      </div>
      <div className='email flex-container--bottom-10'>xpartforparts@gmail.com</div>
      <a
        className='email-link flex-container--bottom-10'
        href='mailto:xpart.in.ua@gmail.com?subject=Question from user'
        target='_blank' rel="noopener noreferrer"
      >
        Надіслати лист на пошту
      </a>
    </div>
    <div className='footer__section'>
      <div className='flex-container--center'>
        <img src={XIcon} alt='xpart-icon' width={59} height={61} />
        <div className='page__logo-text'>-Part</div>
      </div>
      <span className='privacy'>2024 © Всі права захищені</span>
    </div>
  </footer>
)

const Footer = (props) => {
  const { instagram, telegram, viber, phone, phoneOptions } = props

  return <>
    <FooterMobile {...props} />
    <footer className='footer__desktop'>
      <div className='footer__content'>
      <div className='footer__left-section flex-container--column'>
        <div className='flex-container--center'>
          <img src={XIcon} alt='xpart-icon' width={49} height={51} />
          <div className='page__logo-text'>-Part</div>
        </div>
        <span className='privacy'>2024 © Всі права захищені</span>
      </div>
      {FooterColumns}
      <div className='footer__right-section footer__column' style={{ textAlign: 'right' }}>
        <CustomSelect
          value={phone}
          className='phone phone-dropdown flex-container--bottom-10'
          options={phoneOptions}
        >
          {phone}
        </CustomSelect>
        <div className='socials'>
          <a href={viber} target='_blank' rel="noopener noreferrer">
            <img src={Viber} alt='viber' />
          </a>
          <a href={instagram} target='_blank' rel="noopener noreferrer">
            <img
              src={Instagram}
              alt='instagram'
              width={27}
              height={27}
            />
          </a>
          <a href={telegram} target='_blank' rel="noopener noreferrer">
            <img src={Telegram} alt='telegram' />
          </a>
        </div>
        <div className='email'>xpartforparts@gmail.com</div>
        <a
          className='email-link'
          href='mailto:xpart.in.ua@gmail.com?subject=Question from user'
          target='_blank'
          rel="noopener noreferrer"
        >
          Надіслати лист на пошту
        </a>
      </div>
      </div>
    </footer>
  </>
}

export default Footer
